class SumFields {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.init()
    }
    init() {
        document.querySelectorAll('[data-sum]').forEach(el => {
            new SumFieldItem(el, this)
        })
    }
}

class SumFieldItem {
    constructor(element, parent) {
        this.element = element
        this.parent = parent
        this.id = this.element.dataset.sum
        this.init()
    }

    init() {
        document.querySelectorAll('[data-sum-item="'+this.id+'"]').forEach(el => {
            el.addEventListener('change', () => this.refresh())
        })
    }

    refresh() {
        let sumAll = 0
        document.querySelectorAll('[data-sum-item="'+this.id+'"]').forEach(el => {
            let value = 0
            if ('' !== el.value) {
                value = parseFloat(el.value)
            }
            sumAll += value
        })

        if (0 == sumAll) {
            this.element.value = ''
            return;
        }

        this.element.value = sumAll
    }
}

export default SumFields